import { SparklesIcon } from '@heroicons/react/outline';
import { Button } from '@yoast/ui-library';
import cx from 'classnames';

import PaperFooter from './PaperFooter';

interface PaperActionsProps {
  sparkCost?: number;
  onBack?: () => void;
  variant?: 'ai' | 'primary';
  buttonText: string;
  onButtonClick?: () => unknown;
  isButtonDisabled?: boolean;
  isLoading?: boolean;
}

const PaperActions: React.FC<PaperActionsProps> = ({
  onBack,
  variant = 'ai',
  buttonText,
  onButtonClick,
  isButtonDisabled = false,
  isLoading = false,
}) => (
  <PaperFooter nestedInPaperContent>
    <div
      className={cx(
        // if back button, ensure back appears separately from the button group
        {
          'yst-flex yst-flex-1 yst-flex-col yst-items-start yst-justify-between yst-gap-4 md:yst-flex-row md:yst-items-center md:yst-justify-between':
            onBack,
        },
      )}
    >
      {onBack && (
        <Button
          variant="tertiary"
          onClick={onBack}
          className="yst-no-underline"
        >
          ← Back
        </Button>
      )}
      <div
        className={cx(
          'yst-flex yst-flex-col yst-items-stretch yst-gap-4 md:yst-flex-row md:yst-items-center md:yst-justify-end',
        )}
      >
        <Button
          onClick={onButtonClick}
          variant={variant === 'ai' ? 'primary' : variant}
          style={
            variant === 'ai'
              ? {
                  background:
                    'linear-gradient(102deg, #A61E69 0%, #6366F1 100%)',
                  color: '#fff',
                }
              : {}
          }
          disabled={isButtonDisabled}
          type="submit"
          isLoading={isLoading}
        >
          {variant === 'ai' && <SparklesIcon />}
          {buttonText}
        </Button>
      </div>
    </div>
  </PaperFooter>
);

export default PaperActions;
